class GalleryComponent {
	constructor(component) {
		this.component = component;
		this.galleryLightbox = this.component.querySelector(".lightbox");
		this.instanceSplide = null;
		this.itemsShown = [];
		this.init();
	}

	init() {
		this.triggerCustomSlider(".splide-gallery");
		this.bindEvents();
	}

	bindEvents() {
		const cards = this.component.querySelectorAll('.collection-of-images-card');
		cards.forEach((card, index) => {
			card.addEventListener('click', () => {
				const allFigures = [...document.querySelectorAll('.splide-gallery__list figure')];
				this.itemsShown = allFigures.map(fig => {
					const clone = fig.cloneNode(true);
					return clone;
				});
				this.openGallery(index);
			});
		});
	}

	openGallery(indexItem = 0) {
		this.updatePopupGallery();
		this.renderSplide(indexItem);
		this.addCloseEvent();
		this.galleryLightbox.classList.add('show');
		this.component.classList.add('show-popup-gallery');
		document.body.dataset.openPopupGallery = true;
	}

	updatePopupGallery() {
		let html = '';
		html += '<div class="row middle center">';
		html += '<div class="col-36-30">';
		html += '<i class="icon-close" data-comp="close-gallery-lightbox"></i>';
		html += '<div class="splide popup-splide">';
		html += '<div class="splide__track">';
		html += '<div class="splide__list">';
		if (this.itemsShown?.length) {
			this.itemsShown.forEach(clone => {
				const slide = document.createElement('li');
				slide.classList.add('splide__slide');
				slide.appendChild(clone);
				html += slide.outerHTML;
			});
		}
		html += '</div>';
		html += '</div>';
		html += '</div>';
		html += '</div>';
		html += '</div>';
		this.galleryLightbox.innerHTML = html;
	}

	renderSplide(indexItem) { 
		this.instanceSplide = new Splide(this.galleryLightbox.querySelector('.splide'), 
		{ rewind: true, gap: '2rem', arrows: true, pagination: false, }); 
		
		this.instanceSplide.on('mounted', () => { this.instanceSplide.Components.Controller.go(parseInt(indexItem)); }); 
		this.instanceSplide.mount(); 
	}

	addCloseEvent() {
		const closeBtn = this.galleryLightbox.querySelector('[data-comp="close-gallery-lightbox"]');
		if (closeBtn) {
			closeBtn.addEventListener('click', () => this.closePopupGallery());
		}
		document.addEventListener('click', (e) => {
			const splide = this.galleryLightbox.querySelector('.splide');
			const isClickInsideSplide = splide && splide.contains(e.target);
			if (!isClickInsideSplide && this.galleryLightbox.contains(e.target)) {
				this.closePopupGallery();
			}
		});
	}

	closePopupGallery() {
		this.galleryLightbox.classList.remove('show');
		this.component.classList.remove('show-popup-gallery');
		document.body.dataset.openPopupGallery = false;
		if (this.instanceSplide) {
			this.instanceSplide.destroy();
			this.instanceSplide = null;
		}
		this.galleryLightbox.innerHTML = '';
		this.itemsShown = [];
	}

	triggerCustomSlider(selector, perPage = 12, breakpoint = 960) {
		const el = (typeof selector === 'string') ? document.querySelector(selector) : selector;
		if (!el) return null;
		const list = el.querySelector('.splide__list');
		if (!list) return null;
		const children = Array.from(list.children);
		list.innerHTML = '';
		for (let i = 0; i < children.length; i += perPage) {
			const slide = document.createElement('li');
			slide.classList.add('splide__slide');
			const grid = document.createElement('div');
			grid.classList.add('grid-4x3');
			children.slice(i, i + perPage).forEach(child => {
				grid.appendChild(child);
			});
			slide.appendChild(grid);
			list.appendChild(slide);
		}
		const instance = new Splide(el, {
			type: 'slide',
			perPage: 1,
			gap: '1rem',
			pagination: false,
			breakpoints: {
				[breakpoint]: {
					perPage: 1
				}
			}
		});
		instance.mount();
		this.component.classList.add("show-component");
		return instance;
	}
}

document.querySelectorAll('.collection-of-images').forEach(component => {
	new GalleryComponent(component);
});
